import { render, staticRenderFns } from "./ShoppingListToggleButtonV2.vue?vue&type=template&id=9d06f284&scoped=true&"
import script from "./ShoppingListToggleButtonV2.vue?vue&type=script&lang=js&"
export * from "./ShoppingListToggleButtonV2.vue?vue&type=script&lang=js&"
import style0 from "./ShoppingListToggleButtonV2.vue?vue&type=style&index=0&id=9d06f284&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d06f284",
  null
  
)

export default component.exports